import { render, staticRenderFns } from "./dimension.vue?vue&type=template&id=1a0f6ff3&scoped=true&"
import script from "./dimension.vue?vue&type=script&lang=js&"
export * from "./dimension.vue?vue&type=script&lang=js&"
import style0 from "./dimension.vue?vue&type=style&index=0&id=1a0f6ff3&lang=scss&scoped=true&"
import style1 from "./dimension.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0f6ff3",
  null
  
)

export default component.exports